import { userReducer } from "../reducer/UserReducer.js";

export const reducer = userReducer;
